<template>


	<v-layout justify-center>
		
	<!--v-container grid-list-md text-xs-center-->
		 
 		<!--v-card contain style="margin-bottom:2em;" v-if="files && files.length > 0 && !isUploading"-->
 			 <video v-if="files && files.length === 1 && !isUploading && files[0].uploaded === true" controls>
 			 	<source :src="path + '/' + route.name + '/' +  parseFile(files[0].name)"
 			 		:type="files[0].type"
 			 	>
 			 </video>

 			 


 		<!--/v-card-->
 	</v-layout>
		 	
	<!--/v-container-->
</template>

<script>
	import {parseFileName} from '../../../tools';
	
	export default {
		name: 'VideoAnswers',
		data()
		{
			return{}
		},

		created(){
			/*window.vm.$on('fileUploaded', () => {
				this.$forceUpdate();
			})*/
		},

		methods: {
			parseFile(f)
			{
				return parseFileName(f)
			},
		},

		computed: {
			files: {
				get()
				{
					return this.$store.getters['files/filesToUpload'];
				}
			},

			path: {
				get()
				{	
					let p = this.$store.getters['checkpoints/fullPath'];
					
					return p;
				}
			},

			route: {
				get()
				{
					return this.$store.getters['routes/route']
				}
			},

			newTask: {
				get()
				{
					return this.$store.getters['checkpoints/newTask']
				}
			},

			isUploading:
			{
				get()
				{
					return this.$store.getters['files/isUploading'];
				}
			},

			

		}
	}
</script>

